import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AGENT_ALLIANCE_CHAT_MESSAGES_QUERY_KEY } from './useFetchAllianceChatMessages';

export default function useSendAllianceChatMessage() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      applicationId,
      content,
      attachments,
    }: {
      applicationId: string;
      content?: string;
      attachments?: File[];
    }) => {
      const formData = new FormData();
      if (content) formData.append('content', content);
      attachments?.forEach((file) => formData.append('attachments[]', file));

      const response = await fetch(
        `/agent/api/alliance_applications/${applicationId}/chat_messages`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          credentials: 'include',
          body: formData,
        }
      );
      if (!response.ok) throw new Error('メッセージの送信に失敗しました');
      return response.json();
    },
    onSuccess: (_, { applicationId }) => {
      void queryClient.invalidateQueries({
        queryKey: [...AGENT_ALLIANCE_CHAT_MESSAGES_QUERY_KEY, applicationId],
      });
    },
  });
}
